import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w100 pad15" }
const _hoisted_2 = {
  key: 0,
  class: "w100"
}
const _hoisted_3 = {
  key: 0,
  class: "ofs"
}
const _hoisted_4 = {
  class: "w100",
  style: {"margin-top":"10px","border":"1px solid #efefef"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { width: "" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"3px","margin-left":"-3px"} }, "テンプレを利用", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_9 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_10 = { class: "fs14 fw400" }
const _hoisted_11 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_12 = { class: "fs14 whiteColor fw600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TemplateCell = _resolveComponent("TemplateCell")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "InputMessageModal",
    "content-class": "modalContent shadowContent rad10 ModalNormal posFi"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.tmps && _ctx.tmps.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.showTmpCells)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("table", _hoisted_4, [
                      _hoisted_5,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tmps, (tmp, tmpindex) => {
                        return (_openBlock(), _createBlock(_component_TemplateCell, {
                          key: `${tmpindex}${tmp.id}`,
                          tmp: tmp,
                          onSelect: _ctx.selectTmp,
                          showDeleteButton: false,
                          showEditButton: false
                        }, null, 8, ["tmp", "onSelect"]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("label", {
                class: _normalizeClass(`circle_button fw600 fl centered fs12 blueAround`),
                style: {"width":"120px","padding":"4px 10px","margin-bottom":"5px"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.useTemplate && _ctx.useTemplate(...args)))
              }, _hoisted_7)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_TextareaTag, {
          placeholder: "こんにちは、当日よろしくお願いいたします！",
          style: {"height":"200px"},
          class: "fl fs14 roundForm mw100",
          value: _ctx.typedMessage,
          onInputValue: _ctx.inputMessage
        }, null, 8, ["value", "onInputValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("section", {
            class: "with_white_bg dgrey fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelInput && _ctx.cancelInput(...args)))
          }, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t(`title.cancel`)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("section", {
            class: "w100 skyblueBg fffColor fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
          }, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t(`title.send`)), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}